import Vue from 'vue';
import App from './App.vue';

// Store
import store from './store';

// Router
import router from './router';
import Router from 'vue-router';
Vue.use (Router);

// Multi Language
import './ml';

// Browser detection
const {detect} = require ('detect-browser');
const browser = detect ();

// Accordion
import VShowSlide from 'v-show-slide';
Vue.use (VShowSlide);

// Page Visibility
import visibility from 'vue-visibility-change';
Vue.use(visibility);

// Scroll to
import VueScrollTo from 'vue-scrollto';
Vue.use (VueScrollTo, {
  container: 'body',
  duration: 300,
  easing: 'ease',
  offset: -100,
});

// Js Media queries
import tvaMq from './tvaMq';
Vue.use (tvaMq, {
  mobile: 768,
  tablet: 768,
  desktop: Infinity,
  large: Infinity,
});

// Touch gestures
import Vue2TouchEvents from 'vue2-touch-events';
Vue.use (Vue2TouchEvents);

// Json viewer
import JsonViewer from 'vue-json-viewer';
Vue.use (JsonViewer);

// Social sharing
import SocialSharing from 'vue-social-sharing';
Vue.use (SocialSharing);

// Svg icon
import VueSVGIcon from 'vue-svgicon';
import 'vue-svgicon/dist/polyfill';
Vue.use (VueSVGIcon);

// Global Variables
Vue.prototype.$retina = window.devicePixelRatio > 1; // Boolean: true is a retina or more dense device
Vue.prototype.$touchDevice = 'ontouchstart' in document.documentElement; // Boolean: true is a touch device
Vue.prototype.$isIE = browser.name === 'ie';

// VUE
Vue.config.productionTip = false;

new Vue ({
  router,
  store,
  render: h => h (App),
  mounted: () => document.dispatchEvent (new Event ('x-app-rendered')),
}).$mount ('#app');
